import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";
import { Loader } from "@/components/Loader";
import { Bell } from "lucide-react";

export default function NotificationsPage() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/nurse/notifications").then((r) => setData(r.data)).catch((e) => toast.error(apiError(e)));
    api.post("/nurse/notifications/read").catch(() => {});
  }, []);
  if (!data) return <Loader />;

  return (
    <div className="space-y-4" data-testid="nurse-notifications">
      <h1 className="text-[24px] font-bold text-[#1c1b1b]">Notifications</h1>
      {data.items.length === 0 && (
        <div className="text-center text-[#434654] py-12" data-testid="notifications-empty">
          <Bell className="w-8 h-8 mx-auto mb-2 text-[#9CA3AF]" />
          <p className="text-sm">No notifications yet.</p>
        </div>
      )}
      <div className="space-y-3">
        {data.items.map((n) => (
          <button key={n.id} data-testid={`notification-${n.id}`}
            onClick={() => n.link && n.link.startsWith("/app") && navigate(n.link)}
            className={`w-full text-left bg-white rounded-lg border p-4 transition-colors ${n.read ? "border-[#E5E7EB]" : "border-[#003d9b]"}`}>
            <p className="font-semibold text-[#1c1b1b]">{n.title}</p>
            <p className="text-sm text-[#434654] mt-1">{n.message}</p>
          </button>
        ))}
      </div>
    </div>
  );
}
